<template>
  <el-dialog title="Alterar Vencimento do Aluguel" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="700px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">
      <el-row :gutter="10" style="margin-bottom:20px;">
        <el-col :span="24">
           <strong>Selecione abaixo o vencimento que será alterado: </strong>
          <el-table
            :data="mesesFinalizacao"
            empty-text="Nenhum vencimento encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row
            @row-click="selecionarRecibo">
            <el-table-column label="Mês Série" prop="mesSerie" width="100"/>
            <el-table-column label="Data de Vencimento" prop="dataVencimento"/>
            <el-table-column label="Início do Período" prop="inicioPeriodo" width="130"/>
            <el-table-column label="Fim do Período" prop="fimPeriodo" width="130"/>
            <el-table-column label="Vencimento Anterior" prop="dataVencimentoAnterior" width="140"/>
          </el-table>

        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-bottom: 20px;" v-if="novoVencimento && vencimentoIsAlterado || (this.novoVencimento == undefined && this.reciboSelecionado != undefined) || (this.reciboSelecionado != undefined && vencimentoIsAlterado)">
        <el-col :span="12">
          <el-form-item label="Novo Vencimento">
            <el-date-picker
              v-model="novoVencimento"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-bottom: 20px;" v-if="reciboSelecionado && vencimentoIsAlterado">
        <el-col :span="12">
          A data deve ser entre {{ dataInicial }} a {{ dataFinal }}
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="">
            <el-checkbox-group v-model="naoCobrarDiasProporcionais" v-if="vencimentoIsAlterado">
              <el-checkbox label="Não cobrar os dias proporcionais" name="naoCobrarDiasProporcionais"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="">
            <el-checkbox-group v-model="alterarPeriodoRecibos" v-if="vencimentoIsAlterado">
              <el-checkbox label="Alterar período dos Recibos de acordo com novo vencimento" name="alterarPeriodoRecibos"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="alterarHandler" v-if="reciboSelecionado && !reciboSelecionado.dataVencimentoAnterior" type="primary" size="small" round class="btn-box-shadow">Alterar</el-button>
      <el-button @click="cancelarHandler" v-if="reciboSelecionado && reciboSelecionado.dataVencimentoAnterior" type="primary" size="small" round class="btn-box-shadow">Cancelar Alteracao</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapState } from "vuex";
import Util from "../../../util/funcoes.js";

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      naoCobrarDiasProporcionais: false,
      alterarPeriodoRecibos: true,
      reciboSelecionado: undefined,
      mesesFinalizacao: [],

      dataInicial: Date,
      dataFinal: Date,
      novoVencimento: undefined
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    util() {
      return Util;
    },

    vencimentoIsAlterado() {
      return this.reciboSelecionado == undefined ? undefined : this.reciboSelecionado.dataVencimentoAnterior ? false : true
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore", [
      "recuperarMesSerieFinalizacao",
      "alterarDataVencimento",
      "cancelarAlteracaoVencimento"
      ]),

    iniciar() {
      const payload = {
        ...this.aluguel,
        alterarVencimento: true
      }

      this.showLoading();
      this.recuperarMesSerieFinalizacao(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.mesesFinalizacao = resultado.lista
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    selecionarRecibo(row) {
      this.reciboSelecionado = row
      this.novoVencimento = row.dataVencimento
      this.dataInicial = this.util.primeiroDiaMesData(row.dataVencimento)
      this.dataFinal = this.util.adicionarMeses(this.util.stringParaData(row.dataVencimento),1)
      this.dataFinal = this.util.dataParaString(this.dataFinal)

    },

    alterarHandler() {
      if(this.novoVencimento == null || this.novoVencimento == undefined || this.novoVencimento == "") {
        this.$message.warning("Insira uma nova data de vencimento.");
        return;
      }
				if(this.dadosValidosAlteracao()) {
					if(this.existemBoletosRemetidos()) {

            this.$confirm("Você tem certeza que deseja alterar a data do vencimento para " + this.novoVencimento +" ? Existem boletos remetidos ao banco que serão modificados e uma nova remessa será necessária.", "Atenção", {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning"
            }).then(() => {
              this.alterarDataVencimentoHandler();
            });

					} else {
            this.$confirm("Você tem certeza que deseja alterar a data do vencimento para " + this.novoVencimento +" ?", "Atenção", {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning"
            }).then(() => {
              this.alterarDataVencimentoHandler();
            });
					}
				} else {
					if(this.novoVencimento.split("/")[0] == 31) {
						this.exibirAlert("O dia do novo vencimento não pode ser 31", "Atenção");	
					} else {
						this.exibirAlert("O data do novo vencimento está fora do período", "Atenção");
					}
				}
			},
      
			dadosValidosAlteracao() {
				if(this.util.compararDatas(this.novoVencimento, this.dataInicial) >= 0 && this.util.compararDatas(this.novoVencimento, this.dataFinal) <= 0) {
					if(this.util.diaDaData(this.novoVencimento) == 31) {
						return false;
					} else {
						return true;
					}
				} else {
					return false;
				}
			},
			
			alterarDataVencimentoHandler() {
					let params = {
            aluguel: {}
          };
					
					params.aluguel.id = this.aluguel.id;
					params.mesSerie = this.reciboSelecionado.mesSerie;
					params.novoVencimento = this.util.stringParaData(this.novoVencimento);
          params.naoCobrarDiasProporcionais = this.naoCobrarDiasProporcionais;
          params.alterarPeriodoRecibos = this.alterarPeriodoRecibos;
					
					this.showLoading();
          this.alterarDataVencimento(params)
          .then(resultado => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              default:
                this.$message.warning(resultado.mensagem);
            }
          }).catch(() => {
            this.$message.error("Não foi possível conectar-se ao servidor");
            this.hideLoading();
          });
			},
			
			cancelarHandler() {
				if(this.dadosValidosCancelamento()) {
					if(this.existemBoletosRemetidos()) {
            this.$confirm("Você tem certeza que deseja cancelar a alteração de vencimento? Existem boletos remetidos ao banco que serão modificados e uma nova remessa será necessária.", "Atenção", {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning"
            }).then(() => {
              this.cancelarAlteracao();
            });
					} else {
            this.$confirm("Você tem certeza que deseja cancelar a alteração de vencimento?", "Atenção", {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning"
            }).then(() => {
              this.cancelarAlteracao();
            });
					}
				} else {
					this.exibirAlert("Existe uma outra alteração em um mes série posterior ao selecionado, você precisa cancelar esta alteração primeiro", "Atenção");
				}
			},
			
			dadosValidosCancelamento() {
        let response = true
        this.mesesFinalizacao.forEach(item => {
          if(item.dataVencimentoAnterior && item.dataVencimentoAnterior != "" && item.mesSerie > this.reciboSelecionado.mesSerie) {
            response = false;
					}
        });
				return response;
			},
			
			existemBoletosRemetidos() {
        let response = false
        this.mesesFinalizacao.forEach(item => {
          if(item.sequencialRemessa && item.sequencialRemessa != "" && item.mesSerie > this.reciboSelecionado.mesSerie) {
						response = true;
					}
        });
				return response;
			},
			
			cancelarAlteracao() {
					let params = {
            aluguel: {}
          };
					
					params.aluguel.id = this.aluguel.id;
					params.dataVencimentoAnterior = this.reciboSelecionado.dataVencimentoAnterior;
					params.dataVencimento = this.reciboSelecionado.dataVencimento;
					params.mesSerie = this.reciboSelecionado.mesSerie;
        
          this.showLoading();
          this.cancelarAlteracaoVencimento(params)
          .then(resultado => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar()
                break;
              default:
                this.$message.warning(resultado.mensagem);
            }
          }).catch(() => {
            this.$message.error("Não foi possível conectar-se ao servidor");
            this.hideLoading();
          });
			},
    exibirAlert(mensagem, titulo) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },

    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
